import React from 'react'
import { Box, Typography } from "@mui/material"
import { analyzerFilters, openEvolutionModal } from "Pages/AnalyzersV2/@signals"
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"
import { dateFormatReceiver } from "@utils"
import { formatDate, stringToDate } from '@ui-seeker/utils'

export default function AnalyzerHeaderTable({ label, columnKey, rowKey, rowValues, evolutionColumnValues }) {

	const handleOpenEvolutionModal = () => {
		openEvolutionModal.value = {
			filters: analyzerFilters.value,
			price_data: {
				[columnKey]: evolutionColumnValues[label][0][columnKey],
				[rowKey]: rowValues,
			},
			tableRows: evolutionColumnValues[label]
		}
	}
	const formattedLabel = format => dateFormatReceiver(label) ? formatDate(label, {
		receivedFormat: dateFormatReceiver(label),
		isString: true,
		format: format
	}) : label

	return (
		<TooltipSeeker title="Show Evolution Chart">
			<Box
				sx={{
					my: 0.5,
					cursor: "pointer",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					transition: "background-color 0.3s ease",
					"&:hover .inner-box": {
						backgroundColor: "rgba(0, 0, 0, 0.1)",
					}
				}}
				onClick={handleOpenEvolutionModal}
			>
				<Box
					className="inner-box"
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						gap: 0.3,
						padding: 0.5,
						borderRadius: "5px",
						transition: "transform 0.3s ease",
						flexDirection: 'column',
					}}
				>
					{dateFormatReceiver(label) && <Typography variant="subtitle2">
						{formattedLabel('eeee')}
					</Typography>}
					<Typography variant="subtitle2">
						{formattedLabel('dd MMM yyyy')}
					</Typography>
				</Box>
			</Box>
		</TooltipSeeker>
	)
}
